import React from "react";
import SignUpForm from "../components/alooba-for-work-sign-up/SignUpForm";
import Footer from "../components/Footer";
import Layout from "../components/Layout";
import Navbar from "../components/Navbar";
import SEO from "../components/SEO";

export default function AloobaForWorkSignUp() {
  return (
    <Layout>
      <SEO 
        title="Get Started with Alooba For Work | alooba.com"
        description="Are you looking to assess your data candidates? Sign up now to access Alooba Recruiter."
      />
      <Navbar dark="true" />
      <SignUpForm />
      <Footer />
    </Layout>
  )
}
